var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vb-modal',{attrs:{"vb_options":{
    id: _vm.modal_id,
    title: _vm.name_label,
    body_class: 'room-modal',
    header_class: 'room-modal__header',
    centered: true,
    hide_footer: true,
    size: 'lg',
  }}},[(_vm.images.length)?_c('carousel',{staticClass:"room-modal__gallery",attrs:{"images":_vm.images}}):_vm._e(),_c('h5',{staticClass:"room-modal__title",domProps:{"innerHTML":_vm._s(_vm.name_label)}}),(_vm.board_label)?_c('p',{staticClass:"room-modal__board"},[_c('vb-icon',{staticClass:"mr-1",attrs:{"name":'cutlery',"size":16}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.board_label)}})],1):_vm._e(),_c('p',{staticClass:"room-modal__description",domProps:{"innerHTML":_vm._s(_vm.description)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }